<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <!-- 主内容 -->
<!--    <div class="newstxtbox">-->
<!--      <div class="content">-->
<!--        <div class="ny_nr">-->
<!--          <div class="ny_lm">-->
<!--            <div class="ny_bt">-->
<!--              <h4><i>C</i>CHANGE INFORMATION</h4>-->
<!--              <h1>千界资讯</h1>-->
<!--            </div>-->
<!--            <div class="ny_ej">-->
<!--              <ul>-->
<!--                <li v-for="(item,index) in cateList"><a href="javascript:;" :class="[cid == item.id?'cur':'']" @click="changeCate" :data-cid="item.id" :data-catename="item.name">{{item.name}}</a></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="ny_wz">-->
<!--            <h3>{{cate_name}}</h3>-->
<!--            <em></em>-->
<!--          </div>-->
<!--          <div class="ny_qy">-->
<!--            <div class="xw_lb">-->
<!--              <ul>-->
<!--                <li v-for="(item,index) in list">-->
<!--                  <div class="row">-->
<!--                    <div class="news-left">-->
<!--                      <div class="t_p">-->
<!--                        <a href="javascript:;" @click="newsDetail" :data-id="item.id">-->
<!--                          &lt;!&ndash; <img :src="base_url+item.imgUrl" /> &ndash;&gt;-->
<!--                          <img src="/static/images/news/news.jpg">-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="news-right">-->
<!--                      <div class="w_z">-->
<!--                        <h3><a href="javascript:;" @click="newsDetail" :data-id="item.id">{{item.title}}</a></h3>-->
<!--                        <p>{{item.brief}}</p>-->
<!--                        <span><i class="fa fa-clock-o"></i>{{item.addTime}}</span> <a href="javascript:;" class="x_q" @click="newsDetail" :data-id="item.id">查看详情 +</a>-->
<!--                        <div class="clear"></div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--            &lt;!&ndash; 分页 &ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="news-container">
      <div class="head-cate">
        <span :data-id="0" :class="{'is-light': '' == type}" @click="changeType($event)">全部文章</span>
        <span :data-id="1" :class="{'is-light': 1 == type}" @click="changeType($event)">公司动态</span>
        <span :data-id="2" :class="{'is-light': 2 == type}" @click="changeType($event)">媒体报道</span>
      </div>
      <div class="news-list">
        <div class="news-item" v-for="(item,index) in newsInfo" :key="index" @mouseenter="isLight($event)" :data-index="index">
          <div class="news-item-img"><img :src="item.img"></div>
          <div class="news-item-brief" :class="{'is-light': index == islight}" @mouseenter="isLight($event)" :data-index="index" :data-id="item.id" @click="newsDetail($event)">
            <div class="news-item-name">{{item.name}}</div>
            <div class="news-item-context">{{item.context}}</div>
            <div class="news-item-author">
<!--              <span>发表作者{{item.author}}</span>-->
              <span>{{item.addtime}}</span>
            </div>
          </div>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="size"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
var CONFIG = require('@/common/config.js')
var base_url = CONFIG.API_URL.BASE_URL
var img_url = CONFIG.API_URL.IMG_URL

export default {
  data () {
    return {
      base_url: base_url, // base_url
      cateList: [], // 分类列表
      cid: 0, // 分类id
      cate_name: '', // 分类名称
      list: [], // 列表
      newsInfo: [],
      total: 0,
      size: 0,
      type: '',
      limit: 8,
      page: 1,
      currentPage3: 0,
      islight:0
    }
  },
  created: function () {
    var that = this
    // 新闻动态
    // that.getNewList()
    // 获取资讯分类
    that.getCateList()

    that.getPageingNews(this.page)
  },
  methods: {
    // 获取资讯分类
    getCateList: function () {
      var that = this
      axios.post(base_url + 'front/getInfoCateList', {'type': 2}).then(function (res) {
        // console.log(res);
        if (res.data.code == 0) {
          var dataList = res.data.result
          that.cateList = dataList
          that.cid = dataList[0]['id']
          that.cate_name = dataList[0]['name']

          // 获取分页数据
          // GetList(that, 0)
        }
      }).catch(function (err) {
        // console.log(err);
      })
    },
    handleCurrentChange ($event) {
      var that = this
      that.getPageingNews($event)
    },
    handleSizeChange  ($event) {

    },
    changeType ($event) {
      var that = this;
      var type = $event.target.dataset.id
      if (type == 0) {
        that.type = ''
      } else {
        that.type = type
      }
      that.getPageingNews(that.page)
    },

    isLight ($event) {
      var that = this
      that.islight = $event.target.dataset.index
    },
    // 获取分页新闻数据
    getPageingNews (page) {
      var that = this
      var limit = that.limit
      var type = that.type
      axios.post(base_url + 'front/pagingInfo', {'limit': limit, 'page': page, 'type': type}).then(function (res) {
        // console.log(res)
        var result = res.data.result.records
        var list = []
        for (var i = 0; i < result.length; i++) {
          var News = []
          News['img'] = img_url + result[i]['imgUrl']
          News['name'] = result[i]['title']
          News['context'] = result[i]['brief']
          News['id'] = result[i]['id']
          News['addtime'] = result[i]['addTime'].substr(0, 4) + '年' + result[i]['addTime'].substr(5, 2) + '月' + result[i]['addTime'].substr(8, 2) + '日'
          list.push(News)
        }
        // 渲染页面数据
        that.newsInfo = list
        that.size = res.data.result.size
        that.total = res.data.result.total
        // console.log(that.newsInfo)
      }).catch(function (err) {
        // console.log(err)
      })
    },

    getNewList () {
      var that = this
      axios.post(base_url + 'front/getNewList', {}).then(function (res) {
        var result = res.data.result
        if (res.data.code == 0) {
          for (var i = 0; i < result.length; i++) {
            var News = []
            News['img'] = img_url + result[i]['imgUrl']
            News['name'] = result[i]['title']
            News['context'] = result[i]['brief']
            News['id'] = result[i]['id']
            News['addtime'] = result[i]['addTime'].substr(0, 4) + '年' + result[i]['addTime'].substr(5, 2) + '月' + result[i]['addTime'].substr(8, 2) + '日'
            that.newsInfo.push(News)
          }
        }
      }).catch(function (err) {
        // console.log(err)
      })
    },

    // 切换分类
    changeCate: function (e) {
      var that = this
      var cid = e.currentTarget.dataset.cid
      var cate_name = e.currentTarget.dataset.catename
      that.cid = cid
      that.cate_name = cate_name

      // 获取分页数据
      page = 1
      that.list = []
      GetList(that, 0)
    },

    // 资讯详情
    newsDetail: function ($event) {
      var that = this
      var id = $event.currentTarget.dataset.id
      that.$router.push({ path: '/newsDetail?id=' + id })
      // 储存导航标识
      localStorage.setItem('navIndex', '6')
    }

  }
}
</script>

<style scoped>
  @import url("./news.css");
</style>



// WEBPACK FOOTER //
// src/views/news/news.vue